// plugins/echo.client.js
import { defineNuxtPlugin, useRuntimeConfig } from '#app';

export default defineNuxtPlugin(async (nuxtApp) => {
    // only run in the browser
    if (!true) return;

    // dynamically import so SSR build never sees these
    const { default: Pusher } = await import('pusher-js');
    const { default: Echo   } = await import('laravel-echo');

    // expose Pusher globally (Echo needs it)
    window.Pusher = Pusher;

    // grab your public runtime config
    const { pusherKey, pusherCluster, apiBase } = useRuntimeConfig().public;

    if (!pusherKey || !pusherCluster) {
        console.warn(
            '[echo.client] Missing pusherKey or pusherCluster in runtimeConfig.public'
        );
        return;
    }

    const authToken = localStorage.getItem('userToken') || '';

    const echo = new Echo({
        broadcaster:  'pusher',
        key:          pusherKey,
        cluster:      pusherCluster,    // ← required!
        forceTLS:     true,
        authEndpoint: `${apiBase}/broadcasting/auth`,
        auth: {
            headers: {
                Authorization: authToken ? `Bearer ${authToken}` : ''
            }
        }
    });

    // **Single registration**: expose it as `this.$echo` / `useNuxtApp().$echo`
    nuxtApp.provide('echo', echo);
});
